// extracted by mini-css-extract-plugin
module.exports = {"desktop__filter__wrapper":"styles_desktop__filter__wrapper__28jse"};